import { render, staticRenderFns } from "./callsetting.vue?vue&type=template&id=f6cb6d64"
import script from "./callsetting.vue?vue&type=script&lang=js"
export * from "./callsetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports